module.exports = __webpack_public_path__ + "static/media/image3.3634325f.jpg";